import React, { lazy, Suspense } from "react";
import PageLoading from "../components/DesignSystem/PageLoading";
import { Container } from "../components/DesignSystem/SelfTissus/ContainersST";
import PanierAccueilST from "../components/Panier/PanierAccueil";

const Footer1ST = lazy(() => import("../components/FooterST/Footer1_ST"));
const Footer2ST = lazy(() => import("../components/FooterST/Footer2_ST"));
const Footer3ST = lazy(() => import("../components/FooterST/Footer3_ST"));
const Footer4ST = lazy(() => import("../components/FooterST/Footer4_ST"));

export default function Panier_ST() {
  return (
  
    <Suspense fallback={<PageLoading/>}>
    <Container>
      <PanierAccueilST/>
    </Container>
    <Footer1ST />
    <Footer2ST />
    <Footer3ST />
    <Footer4ST />
    </Suspense>
    
  );
}

